import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { RunReportComponent } from "../components";

class RunReport extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "Run historical",
            title: "Run historical Report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Run historical Report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <RunReportComponent />
            </Base>
        );
    }
}

export default RunReport;
